export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-thumbnail-960-b284419030d60ab8cc59cf3cb45802b0.png";